<div *ngIf="pacientes.length > 0" class="flex flex-col mt-10">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Paciente
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Data de Nascimento
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Documento
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Criado em
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Classificação de Risco
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue">
                Mais
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let paciente of pacientes">
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ paciente.name }}
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ paciente.birthDate | date: 'dd/MM/yyyy' }}
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ paciente.document }}
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ paciente.createdAt | date: 'dd/MM/yyyy' }}
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                <div class="flex items-center gap-2">
                  <span
                    class="block w-3 h-3 rounded-full"
                    [ngClass]="{
                      'bg-status-success': paciente.riskClassification === 'Normal',
                      'bg-status-warning': paciente.riskClassification === 'Médio',
                      'bg-status-error': paciente.riskClassification === 'Alto',
                      'bg-gray-400': paciente.riskClassification === 'Não classificado'
                    }"
                  ></span>
                  <span>{{ paciente.riskClassification }}</span>
                </div>
              </td>
              <td class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue">
                <button
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  title="Visualizar Prontuário"
                  (click)="visualizarProntuario(paciente)"
                >
                  <mat-icon class="w-6 h-6">
                    <img src="./assets/icons/visibility.svg" alt="Visualizar" />
                  </mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="flex justify-end mb-5">
    <app-paginacao
      [numeroDeItens]="dadosPaginacao.itensTotal"
      [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
      [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
      [totalPage]="dadosPaginacao.totalPaginas"
      (mudouPagina)="mudouPagina.emit($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
    ></app-paginacao>
  </div>
</div>
<app-no-results-found [condition]="pacientes.length === 0"></app-no-results-found>
